
export default class CovidPatientEvolution {
    id=""
    date=new Date()
    covidPatient=""
    evolution=""
    user=""
    status=""


}


// WEBPACK FOOTER //
// ./src/model/CovidPatientEvolution.js